export default "__VITE_ASSET___GQa5pGz__"